// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"366ccb1a","366":"ead8cf86","451":"ead8cf86","476":"ead8cf86","510":"ead8cf86","863":"ead8cf86"}[chunkId] + ".chunk.css";
};